import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import client from '../api/client';

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.get(`/blog/${slug}/`).then(res => setPost(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="landing"><div className="blog-page"><p>Loading...</p></div></div>;
  if (!post) return <div className="landing"><div className="blog-page"><p>Article not found.</p></div></div>;

  const renderContent = (md) => {
    return md
      .replace(/^### (.+)$/gm, '<h3>$1</h3>')
      .replace(/^## (.+)$/gm, '<h2>$1</h2>')
      .replace(/^# (.+)$/gm, '<h1>$1</h1>')
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.+?)\*/g, '<em>$1</em>')
      .replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2">$1</a>')
      .replace(/^- (.+)$/gm, '<li>$1</li>')
      .replace(/(<li>.*<\/li>\n?)+/g, '<ul>$&</ul>')
      .replace(/\n\n/g, '</p><p>')
      .replace(/^(?!<[h|u|l|p])/, '<p>')
      + '</p>';
  };

  return (
    <>
      <Helmet>
        <title>{post.meta_title || post.title} — Tradrin Blog</title>
        <meta name="description" content={post.meta_description || post.excerpt} />
        <meta property="og:title" content={post.meta_title || post.title} />
        <meta property="og:description" content={post.meta_description || post.excerpt} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`https://tradrin.com/blog/${post.slug}`} />
        {post.cover_image && <meta property="og:image" content={post.cover_image} />}
        <link rel="canonical" href={`https://tradrin.com/blog/${post.slug}`} />
      </Helmet>
      <div className="landing">
        <nav className="landing-nav">
          <Link to="/" className="landing-logo">Tradrin</Link>
          <div className="landing-nav-links">
            <Link to="/">Home</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/login" className="landing-nav-login">Sign In</Link>
          </div>
        </nav>
        <article className="blog-post-page">
          <Link to="/blog" className="blog-back">&larr; Back to Blog</Link>
          <h1>{post.title}</h1>
          <div className="blog-post-meta">
            <span>{post.author}</span>
            <span>{new Date(post.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
            {post.tags && post.tags.split(',').map(t => <span key={t} className="blog-tag">{t.trim()}</span>)}
          </div>
          {post.cover_image && <img src={post.cover_image} alt={post.title} className="blog-post-cover" />}
          <div className="blog-post-content" dangerouslySetInnerHTML={{ __html: renderContent(post.content) }} />
        </article>
        <footer className="landing-footer">
          <div className="landing-footer-bottom">
            <span>&copy; {new Date().getFullYear()} Tradrin. All rights reserved.</span>
          </div>
        </footer>
      </div>
    </>
  );
}
